import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\UpdateCompanyController::__invoke
* @see app/Http/Controllers/Company/UpdateCompanyController.php
* @route '/api/company/{company}'
*/
const UpdateCompanyController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCompanyController.url(args, options),
    method: 'put',
})

UpdateCompanyController.definition = {
    methods: ["put"],
    url: '/api/company/{company}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Company\UpdateCompanyController::__invoke
* @see app/Http/Controllers/Company/UpdateCompanyController.php
* @route '/api/company/{company}'
*/
UpdateCompanyController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return UpdateCompanyController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\UpdateCompanyController::__invoke
* @see app/Http/Controllers/Company/UpdateCompanyController.php
* @route '/api/company/{company}'
*/
UpdateCompanyController.put = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCompanyController.url(args, options),
    method: 'put',
})

export default UpdateCompanyController